module.exports = __webpack_public_path__ + "static/media/quotes_empty_state.4e4693df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quotes_empty_state.png
// module id = 812
// module chunks = 17